"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinLogo = void 0;
var react_1 = __importDefault(require("react"));
var react_svg_1 = require("react-svg");
var styled_components_1 = __importDefault(require("styled-components"));
var coins_1 = require("./coins");
var SvgWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    height: ", "px;\n\n    div {\n        height: ", "px;\n        line-height: ", "px;\n    }\n"], ["\n    display: inline-block;\n    height: ", "px;\n\n    div {\n        height: ", "px;\n        line-height: ", "px;\n    }\n"])), function (props) { return props.size; }, function (props) { return props.size; }, function (props) { return props.size; });
var CoinLogo = function (_a) {
    var symbol = _a.symbol, className = _a.className, _b = _a.size, size = _b === void 0 ? 32 : _b, rest = __rest(_a, ["symbol", "className", "size"]);
    return (react_1.default.createElement(SvgWrapper, __assign({ className: className, size: size }, rest),
        react_1.default.createElement(react_svg_1.ReactSVG, { src: coins_1.COINS[symbol], beforeInjection: function (svg) {
                svg.setAttribute('width', size + "px");
                svg.setAttribute('height', size + "px");
            }, loading: function () { return react_1.default.createElement("span", { className: "loading" }); } })));
};
exports.CoinLogo = CoinLogo;
var templateObject_1;
